import { Link } from "react-router-dom";
import BaseCom from "../../../../components/BaseCom";
import Icon from "../../../../components/Icon";
import L from "../../../../components/Lang";
import AppActions from "../../../../components/Solusek/AppActions";
import DataView from "../../../../components/Solusek/DataView";
import { withParamsAndNavigate } from "../../../../components/WithParamsAndNavigate";
import { Pop } from "../../../../components/PopModal";
import { qreq } from "../../../../shared/qrequest";

class AnalyzerList extends BaseCom {

    edit = (item) => {
        this.props.navigate('edit/' + item.id);
    }

    remove = (item) => {
        Pop.showConfirm(<L>Remove Analyzer</L>, <L>Are you sure you want to remove Analyzer <strong>{item.name}</strong>?</L>, async () => {
            try {
                let j = await qreq.postAsync('/api/internal/analyzer/remove', item);
                if (j.errorCode === 0) {
                    this.success(<L>Removed analyzer.</L>);
                    this.rehash();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Analyzer</L></h1>
                <DataView api={'/api/internal/analyzer/list'} hash={this.state.hash} actions={[
                    {
                        label: <Icon icon="faPencil" />,
                        onClick: this.edit
                    },
                    {
                        label: <Icon icon="faTrash" />,
                        danger: true,
                        onClick: this.remove
                    }]} />
                <AppActions>
                    <Link to="edit" role="button" className="btn btn-lg btn-primary">
                        <Icon icon="faPlus" /> <L>New Analyzer</L>
                    </Link>
                </AppActions>
            </div>
        );
    }
}

export default withParamsAndNavigate(AnalyzerList);